module.exports = __webpack_public_path__ + "static/softshellLogoFront-43589fc645451d6c1ff15ac13382dd51.jpg";